var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Shape",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Computer-IT",
    transform: "translate(-832.000000, -448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconspace_Cloud-Download",
    transform: "translate(832.000000, 448.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#E6F0FC",
    id: "Shape",
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8327738,19.1848635 C47.5116262,20.0520846 51,24.1631889 51,29.035991 C51,34.1546691 47.1499609,38.4356126 42.1101049,38.99392 L42,39 L22,39 L21.8898951,38.99392 C16.8500391,38.4356126 13,34.1546691 13,29.035991 C13,23.5030931 17.4766785,19.0169369 23,19.0169369 C23.0665041,19.0169369 23.1329343,19.0175888 23.1992841,19.0188907 C24.1290358,14.4148195 28.1922125,11 33,11 C37.8650098,11 41.9681282,14.4967402 42.8327738,19.1848635 Z",
    fill: "#154E84",
    fillRule: "nonzero",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9431554,37 C45.9456216,36.5295545 49,33.1153278 49,29.035991 C49,24.9221303 45.8943363,21.4869541 41.8458139,21.0611422 C41.3761358,21.0117429 41.005047,20.640491 40.9558538,20.1707913 C40.5307647,16.1120089 37.1030989,13 33,13 C28.8933164,13 25.4637429,16.1173087 25.0431405,20.1804491 C24.9857666,20.734698 24.4864502,21.1351427 23.9329679,21.0707917 C23.6250635,21.0349929 23.3137542,21.0169369 23,21.0169369 C18.582196,21.0169369 15,24.6067169 15,29.035991 C15,33.1153278 18.0543784,36.5295545 22.0568446,37 L41.9431554,37 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#52ABE2",
    id: "Shape",
    points: "29 29 35 29 35 44.1025391 39 44.1274414 32 52 25 44.0952148 29 44.1025391"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFC200",
    id: "Shape",
    points: "29 39 35 39 35 44.1025391 39 44.1274414 32 52 25 44.0952148 29 44.1025391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,29 C28,28.4477153 28.4477153,28 29,28 L35,28 C35.5522847,28 36,28.4477153 36,29 L36,43.1087453 L39.0062255,43.1274608 C39.866189,43.1328146 40.3187458,44.149251 39.747307,44.7919203 L32.747307,52.6644789 C32.3489892,53.1124475 31.6487554,53.1117375 31.2513469,52.6629619 L24.2513469,44.7581768 C23.6793245,44.1122176 24.139004,43.0936366 25.0018311,43.0952165 L28,43.1007063 L28,29 Z M30,30 L30,44.1025391 C30,44.655539 29.551168,45.10355 28.9981689,45.1025374 L27.2248808,45.0992904 L32.0015278,50.4933431 L36.7849417,45.1136707 L34.9937745,45.1025197 C34.4439301,45.0990966 34,44.6523942 34,44.1025391 L34,30 L30,30 Z",
    fill: "#154E84",
    fillRule: "nonzero",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.95ce73bc27cf6ca3c468c2bcc0787459.svg";
export { ForwardRef as ReactComponent };